// @flow

import React from 'react';
import { isBrowser } from 'react-device-detect';
import { body } from 'core/config';
import { jobs as t } from 'helpers/translation';
import Banner from 'components/Banner';
import BtnRounded from 'components/BtnRounded';

import Filters from './Filters';
import JobAlerts from './JobAlerts';

type Props = {
  counts: any,
  search: any,
  urlSearch: string,
  pushToSearch: Function,
  updateSearch: Function,
  showFilters: boolean,
  showAlerts: boolean,
  showInput: boolean,
  toggleVisibility: Function,
  user: any,
  addJobAlert: Function,
  errors: any,
  places: any
};

export default ({ counts, search, urlSearch, pushToSearch, updateSearch, showFilters, showAlerts, showInput, toggleVisibility, user, addJobAlert, errors, places }: Props) => {
  const handleClick = (item) => {
    body.style.overflow = body.style.overflow === 'hidden' ? 'auto' : 'hidden';
    toggleVisibility(item);
  };

  return (
    <div className="col-12 col-lg-4 col-xl-3">
      <div className="jobs-filter__wrapper">
        <div className="jobs-filter__buttons">
          <BtnRounded
            iconBefore='settings'
            text='Filters'
            classes={`btn_shadow${showFilters ? ' active' : ''}`}
            type='primary'
            handleClick={() => handleClick('filters')}
          />
          <BtnRounded
            iconBefore={showAlerts ? 'saved-search' : 'save-search'}
            text={t.btn.job_alert}
            classes={`btn_shadow jobs-filter__save-search${showAlerts ? ' active' : ''}`}
            handleClick={() => handleClick('alerts')}
          />
        </div>

        <JobAlerts
          showAlerts={showAlerts}
          toggleVisibility={toggleVisibility}
          updateSearch={updateSearch}
          search={search}
          showInput={showInput}
          user={user}
          addJobAlert={addJobAlert}
          errors={errors}
        />

        <Filters
          showFilters={showFilters}
          counts={counts}
          search={search}
          pushToSearch={pushToSearch}
          updateSearch={updateSearch}
          toggleVisibility={toggleVisibility}
          urlSearch={urlSearch}
          places={places}
        />

        {isBrowser && <Banner
          slug='job-search'
          classes='mt-5'
          viewEvent='view_sidebar_banner_on_jobs'
          clickEvent='click_on_sidebar_banner_on_jobs'/>}
      </div>
    </div>
  );
};
